import {
  GET_GOLDEN_STORE_REQUEST,
  GET_GOLDEN_STORE_SUCCESS,
  GET_GOLDEN_STORE_FAILURE,
  GET_GOLDEN_STORE_SEARCH_SUCCESS,
  RESET_SEARCH_RESULT,
  GET_GOLDEN_STORE_SEARCH_REQUEST,
  GET_GOLDEN_STORE_SEARCH_FAILURE,
  ADD_GOLDEN_STORE_REQUEST,
  ADD_GOLDEN_STORE_SUCCESS,
  ADD_GOLDEN_STORE_FAILURE,
  ADD_GOLDEN_STORE_RESET,
} from '../actions/action-type';

  const initialState = {
  loading: false,
  isGoldenStoresSuccess: false,
  isGoldenStoresError: false,
  goldenStores: [],
  isSearchSuccess: false,
  isSearchError: false,
  searchGoldenStoresResponse: [],
  isUpdateStoreSuccess: false,
  isUpdateStoreError: false,
  addGoldenStoreResponse: {},
  error: null,
};

const goldenStoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOLDEN_STORE_REQUEST:
      return { ...state, loading: true, error:null };
    case GET_GOLDEN_STORE_SUCCESS:
      return { ...initialState, loading: false, isGoldenStoresSuccess: true, goldenStores: action.payload };
    case GET_GOLDEN_STORE_FAILURE:
        return { ...initialState, loading: false, isGoldenStoresError: true, error: action.payload, goldenStores:[] };
    case GET_GOLDEN_STORE_SEARCH_REQUEST:
      return { ...initialState, loading: true};
    case GET_GOLDEN_STORE_SEARCH_SUCCESS:
      return { ...initialState, loading: false, isSearchSuccess: true, searchGoldenStoresResponse: action.payload};
    case GET_GOLDEN_STORE_SEARCH_FAILURE:
      return { ...initialState, loading: false, isSearchError: true, searchGoldenStoresResponse: action.payload};
    case RESET_SEARCH_RESULT:
      return { ...state, isSearchSuccess: false, isSearchError: false, searchGoldenStoresResponse:[]};
      case ADD_GOLDEN_STORE_REQUEST:
      return { ...initialState, loading: true};
    case ADD_GOLDEN_STORE_SUCCESS:
      return { ...initialState, loading: false, isUpdateStoreSuccess: true, addGoldenStoreResponse: action.payload};
    case ADD_GOLDEN_STORE_FAILURE:
      return { ...initialState, loading: false, isUpdateStoreError: true, addGoldenStoreResponse: action.payload};
    case ADD_GOLDEN_STORE_RESET:
      return { ...state, isUpdateStoreSuccess: false, isUpdateStoreError: false, addGoldenStoreResponse: {} };
    default:
      return state;
  }
};

export default goldenStoreReducer;